import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['list', 'template']

  connect() {
    this.boundOnInput = (event) => this.onInput(event)
    this.listTarget.addEventListener('input', this.boundOnInput)
    this.refreshRemoveButtons()
  }

  disconnect() {
    this.listTarget.removeEventListener('input', this.boundOnInput)
  }

  onInput(event) {
    if (
      event.target.matches('[data-signer-first-name]') ||
      event.target.matches('[data-signer-last-name]')
    ) {
      this.notifyChange()
    }
  }

  add(event) {
    event.preventDefault()
    const fragment = this.templateTarget.content.cloneNode(true)
    this.listTarget.appendChild(fragment)
    this.renumber()
    this.refreshRemoveButtons()
    this.notifyChange()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest('[data-dynamic-signers-row]')
    if (!row) return
    if (this.rows().length <= 1) return

    const ref = row.querySelector('[data-signer-ref]')?.value
    row.remove()
    this.renumber()
    this.refreshRemoveButtons()
    this.notifyChange({ removedRef: ref })
  }

  refreshRemoveButtons() {
    const visible = this.rows().length > 1
    const buttons = this.listTarget.querySelectorAll(
      '[data-dynamic-signers-target~="removeButton"]'
    )
    buttons.forEach((button) => {
      button.classList.toggle('hidden', !visible)
    })
  }

  renumber() {
    this.rows().forEach((row, index) => {
      row.dataset.signerIndex = String(index)

      row.querySelectorAll('[name]').forEach((field) => {
        field.name = field.name.replace(
          /\[signers\]\[(\d+|__INDEX__)\]/,
          `[signers][${index}]`
        )
      })

      row.querySelectorAll('[id]').forEach((field) => {
        field.id = field.id.replace(
          /signature_request_signers_attributes_(\d+|__INDEX__)/,
          `signature_request_signers_attributes_${index}`
        )
      })

      const refInput = row.querySelector('[data-signer-ref]')
      if (refInput) {
        refInput.value = `signer-${index + 1}`
      }

      const orderInput = row.querySelector('[data-signer-order]')
      if (orderInput && !orderInput.value) {
        orderInput.value = String(index + 1)
      }
    })
  }

  rows() {
    return Array.from(
      this.listTarget.querySelectorAll('[data-dynamic-signers-row]')
    )
  }

  notifyChange(detail = {}) {
    const signers = this.rows().map((row, index) => {
      const firstName =
        row.querySelector('[data-signer-first-name]')?.value || ''
      const lastName =
        row.querySelector('[data-signer-last-name]')?.value || ''
      return {
        ref: row.querySelector('[data-signer-ref]')?.value ||
          `signer-${index + 1}`,
        first_name: firstName,
        last_name: lastName,
        name: [firstName, lastName].map((p) => p.trim()).filter(Boolean).join(' '),
      }
    })

    this.dispatch('changed', {
      detail: { ...detail, signers },
      bubbles: true,
    })
  }
}
